import { render } from "./App.vue?vue&type=template&id=6299a447"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6299a447&lang=scss"
import "./App.vue?vue&type=style&index=1&id=6299a447&lang=css"
script.render = render

export default script